import {
  Button,
  Modal,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
  Avatar,
  IconButton,
  Stack,
} from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { ArrowBackBlue, DeleteVector, PurpleClose, Trash } from 'Images';

interface IModal {
  isVisible: boolean;
  closeModal: () => void;
  deleteFile: () => void;
  fileName?: string;
}

export const DeleteModal2 = ({
  closeModal,
  deleteFile,
  isVisible,
  fileName,
}: IModal) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const dictionary = useDictionary(Dictionary, DICTIONARY.General).deleteModal;

  return (
    <Modal
      open={isVisible}
      BackdropProps={{
        sx: { backgroundColor: 'rgba(8, 30, 84, .8)' },
      }}
    >
      <Paper
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '350px', sm: '770px' },
          height: { xs: '350px', sm: '486px' },
          backgroundColor: 'primary.shade_100',
          borderRadius: '16px',
        }}
      >
        <IconButton
          onClick={closeModal}
          sx={{
            position: 'absolute',
            top: isDesktop ? '24px' : '15px',
            right: isDesktop ? '19px' : '15px',
          }}
        >
          <Avatar
            src={PurpleClose}
            alt={Dictionary[DICTIONARY.Requests].deleteFile.deleteModalExitAlt}
          />
        </IconButton>
        <Stack justifyContent={'center'} gap={'56px'} height={'100%'}>
          <Stack alignItems={'center'} gap={'24px'}>
            <Avatar
              src={DeleteVector}
              alt={''}
              sx={{ width: '160px', height: '142px' }}
            />
            <Stack alignItems={'center'} gap={'18px'}>
              <Typography
                sx={{
                  fontSize: { sm: '32px' },
                  fontWeight: { sm: 700 },
                }}
              >
                {dictionary.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: '28px', sm: '28px' },
                  fontWeight: { xs: 400, sm: 400 },
                }}
              >
                {fileName}
              </Typography>
            </Stack>
          </Stack>
          <Stack
            direction={'row'}
            justifyContent={'center'}
            gap={isDesktop ? '40px' : '10px'}
            paddingX={isDesktop ? '0' : '10px'}
          >
            <Button
              onClick={closeModal}
              sx={{
                width: '154',
                height: '46px',
                padding: '12px 24px',
                gap: '4px',
                backgroundColor: '#fff',
                border: '1px solid',
                borderColor: '#3A6EEC',
                borderRadius: '100px',
                boxShadow: '0px 2px 10px rgba(4, 16, 46, 0.06)',
                '&:hover': {
                  backgroundColor: '#fff',
                },
              }}
            >
              <Avatar
                src={ArrowBackBlue}
                alt={''}
                sx={{ width: '20px', height: '20px', rotate: '180deg' }}
              />
              <Typography>{dictionary.cancel}</Typography>
            </Button>
            <Button
              onClick={deleteFile}
              sx={{
                backgroundColor: '#3A6EEC',
                boxShadow: '0px 2px 10px rgba(4, 16, 46, 0.06)',
                borderRadius: '100px',
                padding: '12px 24px',
                width: '154px',
                height: '46px',
                gap: '4px',
                '&:hover': {
                  backgroundColor: '#3A6EEC',
                },
              }}
            >
              <Avatar src={Trash} alt={''} sx={{ height: '0', width: '0' }} />
              <Typography
                sx={{ color: '#fff', fontWeight: 700, fontSize: '18px' }}
              >
                {dictionary.confirm}
              </Typography>
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Modal>
  );
};
